module.exports = __webpack_public_path__ + "img/caijin.b1136a98.png";